import { defineMessages } from '@jutro/locale';

export default defineMessages({
    payments: {
        id: 'ml.gateway.MLPolicyRecentPaymentsComponent.Payments',
        defaultMessage: 'Payments'
    },
    paymentsMayOnlyBeVoided: {
        id: 'ml.gateway.MLPolicyRecentPaymentsComponent.Payments may only be voided the same day prior to 7:30 PM ET.',
        defaultMessage: 'Payments may only be voided the same day prior to 7:30 PM ET.'
    },
    collapse: {
        id: 'ml.gateway.MLPolicyRecentPaymentsComponent.COLLAPSE',
        defaultMessage: 'COLLAPSE'
    },
    viewAll: {
        id: 'ml.gateway.MLPolicyRecentPaymentsComponent.VIEW ALL',
        defaultMessage: 'VIEW ALL'
    },
    prior30Days: {
        'id': 'ml.policy.MLPolicyRecentPaymentsComponent.30 days',
        'defaultMessage': '30 days'
    },
    prior90Days: {
        'id': 'ml.policy.MLPolicyRecentPaymentsComponent.90 days',
        'defaultMessage': '90 days'
    },
    prior6Months:{
        'id': 'ml.policy.MLPolicyRecentPaymentsComponent.6 months',
        'defaultMessage': '6 months'
    },
    prior1Year: {
        'id': 'ml.policy.MLPolicyRecentPaymentsComponent.1 year',
        'defaultMessage': '1 year'
    },
    prior3Years: {
        'id': 'ml.policy.MLPolicyRecentPaymentsComponent.3 years',
        'defaultMessage': '3 years'
    },
    prior5Years: {
        'id': 'ml.policy.MLPolicyRecentPaymentsComponent.5 years',
        'defaultMessage': '5 years'
    },
    showPaymentsFromLast: {
        'id': 'ml.policy.MLPolicyRecentPaymentsComponent.Show payments from last:',
        'defaultMessage': 'Show payments from last:'
    },
    actions: {
        id: 'ml.policy.MLPolicyRecentPaymentsComponent.Actions',
        defaultMessage: 'Actions'
    },
    void: {
        id: 'ml.policy.MLPolicyRecentPaymentsComponent.Void',
        defaultMessage: 'Void'
    },
    voidPaymentSuccessful: {
        id: 'gateway.views.ml-policy-billing.This payment has been successfully voided',
        defaultMessage: 'This payment has been successfully voided.'
    },
    voidPaymentNotReversed: {
        id: 'gateway.views.ml-policy-billing.This payment has been successfully voided. Please check back later for the confirmation.',
        defaultMessage: 'This payment has been successfully voided. Please check back later for the confirmation.'
    },
    voidPaymentFailEA: {
        id: 'gateway.views.ml-policy-billing.EA.We are unable to void the payment at this time. Please try again later.',
        defaultMessage: 'We are unable to void the payment at this time. Please try again later. If this issue continues, contact us by chat or call us at <strong>1-866-539-1315</strong>.'
    },
    voidPaymentFailIA: {
        id: 'gateway.views.ml-policy-billing.IA.We are unable to void the payment at this time. Please try again later.',
        defaultMessage: 'We are unable to void the payment at this time. Please try again later. If this issue continues, contact us by chat or call us at <strong>1-800-255-0332</strong>'
    },
    voidPaymentFailGCS: {
        id: 'gateway.views.ml-policy-billing.GCS.We are currently unable to void the payment. Please try again, and if it still cannot be processed, please submit a same day void referral.',
        defaultMessage: 'We are currently unable to void the payment. Please try again, and if it still cannot be processed, please submit a same day void referral.'
    }
});